export const DIFF_MODAL_TOGGLE = 'DIFF_MODAL_TOGGLE';
export const DIFF_MODAL_CREATE = 'DIFF_MODAL_CREATE';
export const DIFF_MODAL_VIEWTYPE = 'DIFF_MODAL_VIEWTYPE';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ConfigReports/DiffModal/DiffModalConstants.js